var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 20V0M0 0v20M8.116 3.823l-5.469 5.47a1 1 0 0 0 0 1.414l5.469 5.47a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L4.811 10.75H17.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H4.811l4.366-4.366a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0"
  })));
};
export default SvgBack;